import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bus, school-bus"} maskId="square-filled-radius-0-stroke-1-IconBus"><path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V7H1V8H3V11H21V8H23V7H21V3ZM9 5.4H15V4.6H9V5.4Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 12H3V21H7V19H17V21H21V12ZM9 16H6V15H9V16ZM15 16H18V15H15V16Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBus;
